import { PatientFlags, PatientFlagsControllerApi,   } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */

interface Params {
  patientFlags: PatientFlags;
  xTENANTID?: string;
}

export const useAddPatientFlag = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientFlagsControllerApi(getConfigObject()).createPatientFlags(
      params.patientFlags,
      params.xTENANTID
    )
  );
